<template>
	<router-view />
</template>

<script setup>
import { onMounted, ref, computed, watch } from 'vue';
import * as globaljs from '@/components/utils/global';


onMounted(() => {
	const token = globaljs.safeGetItem('token');
	if (token) {
		globaljs.setAuthToken(token);
	}
});
</script>